// LEGACY-V2-BRIDGE — TEMPORARIO. Saca de Rambox 2 a las cuentas que ya son de Rambox 3 y las manda a la consola
// ya logueadas. Se borra con este archivo y sus usos (buscá LEGACY-V2-BRIDGE) el día que se apague la v2, o
// junto con toda esta app. La otra mitad vive en el monorepo: apps/api/src/legacy-v2-bridge/README.md.

const isDev = process.env.NODE_ENV === 'development';

/** El API de Rambox 3, ya con la versión: el API versiona por URI y sin `/v1` contesta 404. */
const V3_API_URL = isDev ? 'http://localhost:3000/v1' : 'https://api.rambox.app/v1';
const CONSOLE_URL = isDev ? 'http://localhost:4201' : 'https://console.rambox.app';

/** Si el API de v3 no contesta en este tiempo, se sigue en la v2: nunca dejamos a nadie colgado acá. */
const TIMEOUT_MS = 6000;

/**
 * A qué pantalla de la consola equivale el lugar de la v2 al que iba la persona. Billing tiene su par en la
 * consola; admin y partners (que todavía no existe en la consola) caen en el inicio.
 */
export function consolePathFor(redirectUri?: string): string {
	if (redirectUri && redirectUri.indexOf(!isDev ? 'billing.rambox.app' : 'localhost:3000') !== -1) return '/billing';
	return '/home';
}

/**
 * Pregunta al API de Rambox 3 si la sesión recién iniciada pertenece a una cuenta (u organización) que ya es
 * v3. Si lo es, devuelve la URL de la consola a la que hay que mandarla, con el código de handoff (`#code=`)
 * para que entre sin volver a loguearse; si no, `null`.
 *
 * Cualquier falla (red, timeout, error del API) devuelve `null`: ante la duda la persona sigue en la v2, que es
 * lo que pasaba antes de este puente. Lo contrario dejaría afuera a usuarios v2 si el API de v3 se cae.
 */
export async function getV3ConsoleUrl(idToken: string, consolePath: string): Promise<string | null> {
	const controller = new AbortController();
	const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
	try {
		const response = await fetch(`${V3_API_URL}/legacy-v2/destination`, {
			method: 'POST',
			// `X-Rambox-Legacy-App`: sólo para la telemetría del API (`legacy_bridge.sent_to_console`), para saber de qué
			// app v2 vino cada rebote. Es opcional: sin él el evento sale igual, con la app como desconocida.
			headers: { Authorization: `Bearer ${idToken}`, 'X-Rambox-Legacy-App': 'auth-legacy' },
			signal: controller.signal,
		});
		if (!response.ok) return null;
		const body: { environment?: string; code?: string | null } = await response.json();
		if (body.environment !== 'v3') return null;
		// Sin código (la consola rechazaría la cuenta: baneada, desactivada…) igual va a la consola: ahí el login
		// de v3 le explica qué pasa. Lo que no hace es quedarse en la v2.
		return `${CONSOLE_URL}${consolePath}${body.code ? `#code=${encodeURIComponent(body.code)}` : ''}`;
	} catch (error) {
		console.error('LEGACY_V2_BRIDGE', 'Could not ask Rambox 3 where this account belongs, staying on v2', error);
		return null;
	} finally {
		clearTimeout(timer);
	}
}
